export default __webpack_public_path__ + "static/media/yia-logo.ac5f08d4.png";